import { StandaloneSearchBoxes } from '../../common/StandaloneSearchBoxes';
import { SchoolSuggestion, TeacherSuggestion } from '../../search/types/typeaheadSuggestions';
import { Svg } from '../../common/Svg';

interface TeacherChooseBoxProps {
    designatedTeacher: TeacherSuggestion | null,
    handleSchoolOrTeacherSelect: (selection: { schoolSuggestion: SchoolSuggestion | null; teacherSuggestion: TeacherSuggestion | null }) => void,
}

const baseSearchURL = baseFrontURL + 'donors/search.html';

export const RecurringDonationLandingTeacherChooseBox = function ({
    designatedTeacher,
    handleSchoolOrTeacherSelect,
} : TeacherChooseBoxProps) {
    if (designatedTeacher) {
        return (
            <div className='designated-teacher-selection'>
                <div className='school-card teacher-card'>
                    <div className='teacher-card-content'>
                        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                        {designatedTeacher.teacherImage && (<img className='teacher-profile-photo' src={designatedTeacher.teacherImage} alt='A photo of this teacher' />)}
                        <div className='teacher-card-info'>
                            <div className='school-location'>
                                <span className='location'><Svg icon='location' />{designatedTeacher.cityName}, {designatedTeacher.stateCode}</span>
                            </div>
                            <h3 className='teacher-name'>
                                {designatedTeacher.teacherName}
                            </h3>
                            <span className='subheader'>
                                {designatedTeacher.schoolName}
                            </span>
                        </div>
                    </div>
                </div>
                <button className='text-link' onClick={ () => handleSchoolOrTeacherSelect({ schoolSuggestion: null, teacherSuggestion: null }) }>Change teacher</button>
            </div>
        );
    }

    return (
        <div>
            <StandaloneSearchBoxes
                searchURL={baseSearchURL}
                baseSearchURL={baseSearchURL}
                detectedLocation={location}
                onSchoolOrTeacherSelect={handleSchoolOrTeacherSelect}
                skipKeywordsSearch={true}
                skipDistrictSearch={true}
                hideZipCodeSearch={true}
                skipSchoolSearch={true}
                skipTeacherSearch={false}
                placeholder={'Search for a teacher'}
            />
            <p className="text-discreet teacher-search-tip">
                <span className="tooltip-wrapper" aria-label="Search tip">
                    Can&apos;t find your teacher? <Svg icon="help" />
                    <span className="hover-tooltip hover-above">
                        Try searching for a teacher with a location or school name.
                    </span>
                </span>
            </p>
        </div>
    );
};
